import React, { useEffect } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Helmet } from "react-helmet";

const AccountSetupPage = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    // Load the Typeform embed script
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        textAlign: "center",
        marginBottom: isMobile ? 10 : 59,
        padding: 5,
      }}
    >
      {/* Meta tags to prevent indexing */}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Account Setup - Banner Day Threads</title>
      </Helmet>

      <Box
        sx={{
          width: isMobile ? "100%" : "65%",
          margin: "0 auto",
          backgroundColor: "#fff",
          padding: 4,
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h4"
          color="#000"
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            mb: 3,
          }}
        >
          Account Setup
        </Typography>

        <Typography
          variant="body1"
          color="#5595DB"
          sx={{
            textAlign: "center",
            fontSize: "1.1rem",
            mb: 5,
          }}
        >
          Please complete the form below to set up your Banner Day Threads account.
        </Typography>

        {/* Typeform Embed */}
        <Box 
          sx={{
            minHeight: "500px",
            width: "100%",
          }}
        >
          <div data-tf-live="01JR0F14AGAC45ASF8FQGRGQXD"></div>
        </Box>
      </Box>
    </Box>
  );
};

export default AccountSetupPage;